
import { Component, Vue } from 'vue-property-decorator'
import TicketCggl from '@/views/Ticket/indexCggl.vue'

@Component({
  name: 'AllOrderLists',
  components: {
    TicketCggl
  }
})
export default class extends Vue {}
